module.exports = __webpack_public_path__ + "static/media/Alert.d7d6c7e8.svg";